import { AttachFile, Close, CloudUpload, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, styled } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonButton from 'components/ArgonButton'
import ArgonTypography from 'components/ArgonTypography';
import { postSubmit } from 'global/postFunc';
import React, { useEffect, useState } from 'react'

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const Tambah = ({ decryptedUser, opd, updating, setUpdating, addReq, tahunAnggaran, ...props }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)

    const [file, setFile] = useState(null)
    useEffect(() => {
        if (open) {
            console.log(file);
        }
    }, [file])

    const submit = (e) => {
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/sa/sumber-pendanaan/tambah',
            {
                file: file
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                setOpen(false)
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                // setOpen(false)
            }
        )
        // console.log('submit');
    }

    return (
        <>
            <ArgonButton
                variant='outlined'
                color="info"
                size="small"
                startIcon={<AttachFile />}
                onClick={handleOpen}
                {...props}
            >
                Import Data
            </ArgonButton>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                scroll='paper'
                p={3}
                component='form'
                onSubmit={submit}
            >
                <DialogTitle>
                    <ArgonTypography variant='body2' fontWeight="bold">Import Data</ArgonTypography>
                </DialogTitle>
                <DialogContent p={3}>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                File
                            </ArgonTypography>
                        </ArgonBox>
                        <>
                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                startIcon={<AttachFile />}
                            >
                                Upload file
                                <VisuallyHiddenInput
                                    type="file"
                                    onChange={(e) => {
                                        setFile(e.target.files[0])
                                    }}
                                    helperText="Some important text"
                                />

                            </Button>
                            {file?.name ? ' '+file.name : ' No File Selected'}
                        </>
                    </ArgonBox>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                        <Grid item>
                            <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Tambah